export default __webpack_public_path__ + "8426fac29c2bb5c99848398e9dd882cc.gltf";